// src/components/Shared/PageTransition.jsx
import React from 'react';

const PageTransition = ({ children }) => {
  return (
    <div className="w-full h-full">
      {children}
    </div>
  );
};

export default PageTransition;